import { useState } from 'react';
import { Link } from 'react-router-dom';
import { UserCircle, Settings, Wrench, LogOut } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';

export default function UserProfile() {
  const { user, profile, signOut } = useAuth();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <DropdownMenu open={isOpen} onOpenChange={setIsOpen}>
      <DropdownMenuTrigger asChild>
        <button
          className="flex items-center gap-2 p-1.5 rounded-full transition-colors hover:bg-slate-100 outline-none focus:ring-2 focus:ring-slate-900/20 focus:ring-offset-2"
        >
          {profile?.avatar_url ? (
            <Avatar className="h-8 w-8">
              <AvatarImage src={profile.avatar_url} alt="Profile" />
              <AvatarFallback className="text-xs bg-slate-100 text-slate-700">
                {(profile?.full_name || user?.email || 'U').charAt(0).toUpperCase()}
              </AvatarFallback>
            </Avatar>
          ) : (
            <div className="h-8 w-8 rounded-full bg-slate-100 flex items-center justify-center">
              <UserCircle className="h-6 w-6 text-slate-600" />
            </div>
          )}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-72 border-slate-200">
        <div className="flex items-center gap-3 p-3 pb-2">
          {profile?.avatar_url ? (
            <Avatar className="h-12 w-12">
              <AvatarImage src={profile.avatar_url} alt="Profile" />
              <AvatarFallback className="bg-slate-100 text-slate-700">
                {(profile?.full_name || user?.email || 'U').charAt(0).toUpperCase()}
              </AvatarFallback>
            </Avatar>
          ) : (
            <div className="h-12 w-12 rounded-full bg-slate-100 flex items-center justify-center">
              <UserCircle className="h-8 w-8 text-slate-600" />
            </div>
          )}
          <div className="flex-1 min-w-0">
            <p className="font-medium truncate text-slate-900">{profile?.full_name || user?.email}</p>
            <p className="text-sm text-slate-600 truncate">{user?.email}</p>
          </div>
        </div>
        <DropdownMenuSeparator />
        <DropdownMenuItem asChild>
          <Link to="/dashboard/settings" className="flex items-center cursor-pointer" onClick={() => setIsOpen(false)}>
            <Settings className="mr-2 h-4 w-4" />
            Settings
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <Link to="/tools" className="flex items-center cursor-pointer" onClick={() => setIsOpen(false)}>
            <Wrench className="mr-2 h-4 w-4" />
            Tools
          </Link>
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={() => signOut()} className="text-red-600 focus:text-red-700 focus:bg-red-50">
          <LogOut className="mr-2 h-4 w-4" />
          Sign Out
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
